<!-- Dialog title -->
<div mat-dialog-title class="main-not-certified">
  <div class="row" *ngIf="data?.data!='Partner_Mapped'">
    <div class="col-12 text-center not-certified">
      <img
        src="assets/icon/not-certified.svg"
        class="not-certified-image"
        alt="close"
      />
      <div class="not-certified-text">
        <span>Sorry!</span><br>
        <span>You are not certified to sell</span><br>
        <span><span class="fw-bold">Motor Insurance</span> yet.</span><br>
      </div>
        <button class="submit-btn btn-understand mt-2" type="submit" (click)="Understand()">
          I Understand
        </button>
    </div>
  </div>
  <div *ngIf="data?.data=='Partner_Mapped'" class="mt-3">
    <div class="message-text text-center">
      <span>{{
        partner_code
          ? ('This Policy will be mapped under ('+partner_code+').')
          : ('This policy is not mapped to any partner code.')
      }}</span>
      <br>
      <b *ngIf="first_name!='null'">{{first_name}}</b><b *ngIf="middle_name!='null' && middle_name!=''">&nbsp;{{middle_name}}</b>&nbsp;<b *ngIf="last_name!='null'">{{last_name}}</b>
    </div>
    <div class="row">
      <div class="col-lg-6" *ngIf="hideLogin">
        <button class="cancel-btn btn-procced mt-2" type="submit" (click)="login()">
          Login
        </button>
      </div>
      <div [ngClass]="hideLogin ? 'col-lg-6':'col-lg-12 d-flex justify-content-center'" >
        <button [ngClass]="hideLogin ? 'btn-procced':'btn-procced-width'"  class="submit-btn  mt-2" type="submit" (click)="loader ? null : procced()">
          <img
          src="assets/gif/button-loader.gif"
          alt="close"
          class="loader me-2"
          *ngIf="loader"
          
        /> Proceed
        </button>
      </div>
    </div>
    
  </div>
</div>
